"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../internal/utils");
/**
 * Runs the value through a list of validators.
 * - As soon as a validation error is detected, the error is returned
 * - As soon as a validator dies unexpectedly (throws an error), we throw the same error.
 */
function applyValidators(value, validators) {
    return new Promise(function (resolve, reject) {
        var currentIndex = 0;
        var gotoNextValidator = function () {
            currentIndex++;
            runCurrentValidator();
        };
        var runCurrentValidator = function () {
            if (currentIndex == validators.length) {
                resolve(null);
                return;
            }
            var validator = validators[currentIndex];
            var res = validator(value);
            // no error
            if (!res) {
                gotoNextValidator();
                return;
            }
            // some error
            if (!utils_1.isPromiseLike(res)) {
                resolve(res);
                return;
            }
            // wait for validator response
            res.then(function (msg) {
                // no error
                if (!msg)
                    gotoNextValidator();
                // some error
                else
                    resolve(msg);
            }).catch(reject);
        };
        // kickoff
        runCurrentValidator();
    });
}
exports.applyValidators = applyValidators;
